import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-ccf-pf',
  templateUrl: './ccf-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./ccf-pf.component.css']
})
export class CcfPfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.ccf===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.ccf===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
